<div
  class="navigation-wrapper"
  [dtWidthTrigger]="{ 'sidenav-over': 800 }"
  (dtWidthTriggerStateChange)="sidenavOver = $event['sidenav-over']"
>
  <dt-navbar (menuClick)="toggleMenu()"></dt-navbar>
  <mat-drawer-container class="content-container">
    <mat-drawer [mode]="sidenavOver ? 'over' : 'side'" [disableClose]="!sidenavOver" [opened]="menuOpened">
      <mat-nav-list class="sidenav-list">
        <a routerLink="/dashboard" routerLinkActive="active" mat-list-item>
          <mat-icon matListItemIcon>dashboard</mat-icon>
          <span matListItemTitle i18n>Dashboard</span>
        </a>
        @if (authService.userHasRole('admin') | async) {
          <a routerLink="/users" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>group</mat-icon>
            <span matListItemTitle i18n>Benutzerverwaltung</span>
          </a>
        }
        @if (authService.userHasRole('quickstart-manager') | async) {
          <mat-divider></mat-divider>
          <div mat-subheader i18n>Vorlagen</div>
          <a routerLink="/quickstart-projects" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>inventory</mat-icon>
            <span matListItemTitle i18n>Projekte</span>
          </a>
          <a routerLink="/quickstart-questions" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>contact_support</mat-icon>
            <span matListItemTitle i18n>Entscheidungsfragen</span>
          </a>
          <a routerLink="/quickstart-hierarchies" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>track_changes</mat-icon>
            <span matListItemTitle i18n>Zielbäume</span>
          </a>
          <a routerLink="/quickstart-values" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>numbers</mat-icon>
            <span matListItemTitle i18n>Werte</span>
          </a>
          <a routerLink="/quickstart-tags" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>label</mat-icon>
            <span matListItemTitle i18n>Tags</span>
          </a>
          <a routerLink="/youtube-videos" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>smart_display</mat-icon>
            <span matListItemTitle i18n>YouTube Videos</span>
          </a>
        }
        @if (hasEventAccess$ | async) {
          <mat-divider></mat-divider>
          <div mat-subheader i18n>Veranstaltungen</div>
          <a routerLink="/events" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>event_upcoming</mat-icon>
            <span matListItemTitle i18n>Übersicht</span>
          </a>
          <a routerLink="/event-export" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>table</mat-icon>
            <span matListItemTitle i18n>Export</span>
          </a>
        }
        @if (authService.userHasRole('klug-manager') | async) {
          <mat-divider></mat-divider>
          <div mat-subheader>KLUGentscheiden</div>
          <a routerLink="/klug" routerLinkActive="active" mat-list-item>
            <mat-icon matListItemIcon>rebase</mat-icon>
            <span matListItemTitle i18n>Übersicht</span>
          </a>
        }
      </mat-nav-list>

      <footer>
        <mat-divider></mat-divider>
        <div class="footer-content mat-caption">
          <div>Entscheidungsnavi Cockpit {{ version }} © {{ year }} EFi</div>
          <div class="footer-links">
            <a href="https://entscheidungsnavi.de/privacy" i18n-href target="_blank" rel="noopener" i18n>Datenschutz</a>
            <a href="https://entscheidungsnavi.de/sitenotice" i18n-href target="_blank" rel="noopener" i18n>Impressum</a>
          </div>
        </div>
      </footer>
    </mat-drawer>
    <mat-drawer-content>
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
